import { createKeys } from '../../CRUD';

export const filterKeys = createKeys('filter');
